import {
  GENERAL_SETTINGS_REQUEST_ASYNC,
  UPDATE_GENERAL_SETTINGS_REQUEST,
  UPDATE_PASSWORD_REQUEST,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,
    passwords: {
      oldPassword: '',
      newPassword: '',
    },
    passwordMessage: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case GENERAL_SETTINGS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case GENERAL_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case GENERAL_SETTINGS_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case GENERAL_SETTINGS_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_GENERAL_SETTINGS_REQUEST.INITIATE:
        return { ...state, loader: true, error: null }
      case UPDATE_GENERAL_SETTINGS_REQUEST.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case UPDATE_GENERAL_SETTINGS_REQUEST.ERROR:
        return { ...state, error: action.error, loader: false }
      case UPDATE_GENERAL_SETTINGS_REQUEST.CANCEL:
        return { ...state, loader: false }
      case UPDATE_PASSWORD_REQUEST.INITIATE:
        return { ...state, passwordMessage: false, loader: true }
      case UPDATE_PASSWORD_REQUEST.SUCCESS:
        return {
          ...state,
          passwords: action.payload.values,
          passwordMessage: true,
          loader: false,
        }
      case UPDATE_PASSWORD_REQUEST.ERROR:
        return { ...state, passwordMessage: action.error, loader: false }
      default:
        return state
    }
  }
}
